import Axios from 'axios'

import {
  standardizeAddressForBigC,
  standardizeOrderFromResponse,
  MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing,
} from '@/services/Standardizers'

import { log, error } from '@/services/Log'
//---------------------------------------------------------------

async function recreateOrder({ order }) {
  log('recoverAvailableShippingOptions START', { order })
  try {
    const originalProductsDistribution = order.shipments.map(({ lineItems, shippingAddress }) => ({
      lineItems: lineItems.map(({
        productId, variantId, quantity,
      }) => ({ productId, variantId, quantity })),
      shippingAddress,
    }))
    const originalLineItems = order.cart.lineItems.map(({
      productId, quantity, variantId,
    }) => ({ productId, quantity, variantId }))
    log({ originalProductsDistribution, originalLineItems })
    // Delete current cart
    log(' Deleting cart', { cart: order?.cart })
    await Axios.delete(`/api/storefront/carts/${order?.cart.id}`)
    // Add Items to new cart
    log('Creating a new cart with previous items', { lineItems: originalLineItems })
    const newCart = (await Axios.post('/api/storefront/carts', { lineItems: originalLineItems })).data
    const newLineItems = [...newCart.lineItems.customItems, ...newCart.lineItems.physicalItems]
    // Create consignments
    const newConsignments = originalProductsDistribution
      .map(({ shippingAddress, lineItems }) => ({
        shippingAddress: standardizeAddressForBigC(shippingAddress),
        lineItems: lineItems.map(({
          productId, quantity, variantId,
        }) => ({
          itemId: newLineItems.find((p) => (
            p.productId === productId && p.variantId === variantId
          ))?.id,
          quantity,
        })),
      }))
    log('Recreating consignments', { newCart, newLineItems, newConsignments })
    const bigcResponse = (await Axios.post(`/api/storefront/checkouts/${newCart?.id}/consignments?include=consignments.availableShippingOptions`, newConsignments))?.data
    const newOrder = standardizeOrderFromResponse({ bigcResponse, order })
    await MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing({ order: newOrder })
    log('New standardized order', { newOrder })
    return { newOrder, success: true }
  } catch (err) {
    error('recoverAvailableShippingOptions ERROR', { err })
  }
  return { success: false }
}

export default recreateOrder
